import PromptDialog from 'components/dialogs/PromptDialog';
import { useTranslation } from 'react-i18next';
import useModal from 'hooks/useModal';
import Api from 'utils/api';


const usePermissionModals = () => {
    const {t} = useTranslation();
    const {showModal, hideModal} = useModal();

    const openAddRoleModal = () => showModal(PromptDialog,
        {},
        {
            title: t('add_title', {value: t('role')}),
            maxWidth: 'xs',
        })
        .then(Api.permissions.createRole)
        .then(hideModal);

    const openAddPermissionModal = () => showModal(PromptDialog,
        {},
        {
            title: t('add_title', {value: t('permission')}),
            maxWidth: 'xs',
        })
        .then(Api.permissions.createPermission)
        .then(hideModal);

    return {
        openAddRoleModal,
        openAddPermissionModal,
    };
};

export default usePermissionModals;
